import {makeReactContext} from 'lib/makeReactContext';
import {ProgressData} from 'llm/chat-library/progress/ProgressTypes';
import {LLMMarkdownTableClassNames} from 'llm/markdown/TableWithCitations';

export type LLMMarkdownClassNames = {
  chip?: string;
  tableCopyButton?: string;
} & LLMMarkdownTableClassNames;

export interface LLMMarkdownDependencies {
  onCitationClick?: (toolId: string, isSourceCitation?: boolean) => void;
  progressData?: ProgressData;
  citationNumberMap?: Map<string, number>;
  chatSessionId?: string;
  classNames?: LLMMarkdownClassNames;
}

export const LLMMarkdownDependenciesContext = makeReactContext<LLMMarkdownDependencies>(
  () => ({}),
  'LLMMarkdownDependenciesContext'
);

export function useLLMMarkdownDependencies(): LLMMarkdownDependencies {
  return LLMMarkdownDependenciesContext.useContext();
}
